import { generateText as generateTextAi, streamText as streamTextAi } from 'ai'
import { aiModelsSchema, getAIModel } from './schema/providers.js'

type GenerateText = Omit<Parameters<typeof generateTextAi>[0], 'model'> & {
  type: 'client' | 'server'
  apiKey: string
  modelName: string
}

/** Thin wrapper around AI SDK generate text  */
export const generateText = ({
  apiKey,
  modelName,
  type = 'server',
  messages = [],
  ...restProps
}: GenerateText): ReturnType<typeof generateTextAi> => {
  const model = getAIModel({ type, authToken: apiKey, model: aiModelsSchema.parse(modelName) })

  return generateTextAi({ model, prompt: messages, ...restProps })
}

type StreamText = Omit<Parameters<typeof streamTextAi>[0], 'model'> & {
  apiKey: string
  type: 'client' | 'server'
  modelName: string
}

export const streamText = ({
  apiKey,
  type = 'server',
  modelName,
  messages = [],
  ...restProps
}: StreamText): ReturnType<typeof streamTextAi> => {
  const model = getAIModel({ type, authToken: apiKey, model: aiModelsSchema.parse(modelName) })
  const prompt = messages ?? []
  return streamTextAi({ model, prompt, ...restProps })
}
